import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, PlanzoneSettings } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectDetailsConfiguration(
    req: Boundaries["editProjectDetailsConfiguration"]["request"],
  ): void;
}

function useEditProjectDetailsConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectDetailsConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectDetailsConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectDetailsConfigurationRequestFailure(planzone),
    ),
    editProjectDetailsConfiguration: core.editProjectDetailsConfiguration,
  };
}

export { useEditProjectDetailsConfiguration };
